var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slogan-container"},[_vm._m(0),_c('h3',{staticClass:"sub-slogan"},[_vm._v(_vm._s(_vm.subSloganText))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"slogan"},[_vm._v("SK's Journey with Challenge,"),_c('br'),_vm._v("Passion and Integrity")])
}]

export { render, staticRenderFns }